import React from 'react';
import { InputItem, Button } from 'antd-mobile';
import { FormattedMessage } from 'react-intl';
import * as PropTypes from 'prop-types';
import loadingIcon from '@/assets/loading.svg';
import './index.scss';

export default class NameInput extends React.Component {
  static propTypes = {
    showTips: PropTypes.bool, // 是否显示提示
    tips: PropTypes.any, // 提示
    onOk: PropTypes.func,
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    placeHolder: PropTypes.string,
    maxLength: PropTypes.number,
  };

  static defaultProps = {
    showTips: false,
    tips: '',
    loading: false,
    placeHolder: '',
    maxLength: 16,
  };

  handleChange = val => {
    const { onChange } = this.props;

    this.inputValue = val;
    onChange && onChange(val);
  };

  handleOk = () => {
    const { onOk, loading, showTips } = this.props;

    if (loading || showTips) return;
    onOk && onOk(this.inputValue);
  };

  render() {
    const { loading, showTips, tips, placeHolder, maxLength } = this.props;

    return (
      <div className="name-input">
        <div className="name-input-area">
          <InputItem
            maxLength={maxLength}
            className="name-input"
            placeholder={placeHolder}
            onChange={this.handleChange}
          />
          <Button
            className="name-btn"
            type="primary"
            onClick={this.handleOk}
            style={{ border: '1pxs solid' }}
          >
            <FormattedMessage id="btn.enter" />
          </Button>
        </div>
        <div className="input-tips">
          {loading ? (
            <img className="loading-icon" src={loadingIcon} alt="" />
          ) : (
            showTips && <div className="error-tips">{tips}</div>
          )}
        </div>
      </div>
    );
  }
}
